<template>
    <div class="bg-dark w-screen h-screen flex items-center justify-center">
        <icon width="457" height="346">
            <IconNotFound />
        </icon>
    </div>
</template>

<script setup lang="ts">
import IconNotFound from '../ui/icons/IconNotFound.vue'
</script>

<style scoped></style>